import React, { Component } from 'react';
import ReportInfoComponent from "./report-info-component";
import {connect} from "react-redux";
import {loadReportInfoRequest} from "./report-info-action-creators";


class ReportInfoContainer extends Component {

  componentDidMount() {
    const { loadReportInfo, reportUrl, whoMounted } = this.props;
    whoMounted !== reportUrl ? loadReportInfo(reportUrl) : null;
  }

  componentDidUpdate(prevProps) {
    const { reportUrl, loadReportInfo } = this.props;
    reportUrl !== prevProps.reportUrl ? loadReportInfo() : null;
  }

  render() {
    return <ReportInfoComponent {...this.props} />
  }
}


const mapStateToProps = (state, ownProps) => ({
  title: state.reportInfo.title,
  dateCreated: state.reportInfo.dateCreated,
  dateDownloaded: state.reportInfo.dateDownloaded,
  loading: state.reportInfo.loading,
  reportUrl: state.report.reportUrl,
  marginBottom: ownProps.marginBottom,
  whoMounted: state.reportInfo.whoMounted,
  error: state.reportInfo.error
});

const mapDispatchToProps = dispatch => ({
  loadReportInfo: reportUrl => dispatch(loadReportInfoRequest(reportUrl))
});



export default connect(mapStateToProps, mapDispatchToProps)(ReportInfoContainer)


// WEBPACK FOOTER //
// ./src/modules/report-info/report-info-container.js